import { ConfigurationTypeImages, DeliveryPeriod } from '@susu/custom-made/utils/interfaces';
import { createContext } from 'react';

type GlobalContextType = {
  isManualSelectionDone: boolean;
  setIsManualSelectionDone: (isManualSelectionDone: boolean) => void;
  deliveryPeriod: DeliveryPeriod | undefined;
  setDeliveryPeriod: (deliveryPeriod: DeliveryPeriod | undefined) => void;
  configurationTypeImages: ConfigurationTypeImages;
  setConfigurationTypeImages: (configurationTypeImages: ConfigurationTypeImages) => void;
  updateConfigurationTypeImages: (configurationTypeImages: ConfigurationTypeImages) => void;
  cmCorrelationId: string;
  setCmCorrelationId: (cmCorrelationId: string) => void;
  isUpsaleShown?: boolean;
  setIsUpsaleShown: (isUpsaleShown: boolean) => void;
  isPreviewPanning: boolean;
  setIsPreviewPanning: (isPreviewPanning: boolean) => void;
  isPreviewZoomed: boolean;
  setIsPreviewZoomed: (isPreviewZoomed: boolean) => void;
  toast: { message: string; isOpen: boolean };
  showToast: (message: string) => void;
  hideToast: () => void;
};

const defaultGlobalContext: GlobalContextType = {
  isManualSelectionDone: false,
  setIsManualSelectionDone: () => {},
  configurationTypeImages: {},
  setConfigurationTypeImages: () => {},
  updateConfigurationTypeImages: () => {},
  deliveryPeriod: undefined,
  setDeliveryPeriod: () => {},
  isPreviewPanning: false,
  setIsPreviewPanning: () => {},
  isPreviewZoomed: false,
  setIsPreviewZoomed: () => {},
  cmCorrelationId: '',
  setCmCorrelationId: () => {},
  isUpsaleShown: false,
  setIsUpsaleShown: () => {},
  toast: { message: '', isOpen: false },
  showToast: () => {},
  hideToast: () => {},
};

export const GlobalContext = createContext<GlobalContextType>(defaultGlobalContext);
